
import axios from "axios";
import AdmButton from "@afe/admirals-dev/src/components/AdmButton/AdmButton.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import PodcastRow from "./podcast-element.vue";

@Component({
  components: {
    PodcastRow,
    AdmButton
  }
})
export default class Podcasts extends Vue {
  @Prop(String) readonly spreaker_id!: string;
  @Prop(String) readonly trans_name!: string;
  @Prop(String) readonly trans_time!: string;
  @Prop(String) readonly trans_plays!: string;
  @Prop(String) readonly trans_share!: string;
  @Prop(String) readonly trans_more!: string;
  @Prop(String) readonly id_play!: string;
  @Prop(String) readonly id_share!: string;
  @Prop(String) readonly id_more!: string;
  @Prop(String) readonly month!: string;
  @Prop(String) readonly link?: string;
  @Prop({ default: 5 }) readonly limit?: string;

  trackTime = 0;
  currentTrackID = 0;
  sortOrder = false;
  isLoading = false;
  nextUrl = "";
  audio = new Audio();
  episodes = [] as string[];

  beforeMount() {
    this.audio.ontimeupdate = this.ontimeupdate;
  }
  mounted() {
    this.fetchPodcasts();
  }
  fetchPodcasts() {
    if (!this.isLoading) {
      this.isLoading = true;
      axios
        .get(
          `https://api.spreaker.com/v2/shows/${
            this.spreaker_id
          }/episodes?limit=${this.limit}${this.sorting()}`
        )
        .then(({ data }) => {
          const { items, next_url } = data.response;
          this.nextUrl = next_url;

          this.episodes = [...items];
          this.isLoading = false;
        });
    }
  }
  sorting() {
    return this.sortOrder ? "&sorting=oldest" : "&sorting=newest";
  }
  toggleSortOrder() {
    this.sortOrder = !this.sortOrder;
    this.audio.src = "";
    this.currentTrackID = 0;
    this.fetchPodcasts();
  }
  morePodcasts() {
    if (!this.isLoading) {
      this.isLoading = true;
      axios.get(this.nextUrl).then(({ data }) => {
        const { items, next_url } = data.response;
        this.nextUrl = next_url;

        this.episodes = [...this.episodes, ...items];
        this.isLoading = false;
      });
    }
  }
  seek(evt: any, id: number) {
    if (this.currentTrackID === id) {
      this.audio.currentTime = evt.target.value;
    }
  }
  ontimeupdate(e: any) {
    this.trackTime = this.audio.currentTime;
  }
  play(src: string, trackId: number) {
    if (trackId !== this.currentTrackID) {
      this.audio.src = src;
      this.currentTrackID = trackId;
    }
    this.audio.play();
  }
  pause(id: number) {
    if (this.currentTrackID === id) {
      this.audio.pause();
    }
  }
  get loadPodcasts() {
    return this.link ? {} : { click: this.morePodcasts };
  }
}
